/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import 'tui-image-editor/dist/tui-image-editor.css';
import * as markerjs2 from 'markerjs2';
import watermark from 'watermarkjs';
import noUser from '../../assets/img/white_img.png';
import { CreateBlobUrl, hotFixCreateBlobUrl } from '../../helper/binarytoblob';

const MarkerEditor = ({
  path,
  setBlobURL,
  setTab,
  blobURL,
  setBlobData,
  setMarkerImageModal,
  setPreviewScreen,
  setMarkerState,
  markerState,
  isSaveAsNew,
  setIsAsNew,
}) => {
  const markerImageRef = React.createRef(); // for MarkerJs
  const [isMarkerOpen, setIsMarkerOpen] = useState(false);

  useEffect(() => {
    showMarkerArea();
  }, []);

  // For Markerjs
  const showMarkerArea = () => {
    if (markerImageRef.current !== null) {
      setIsMarkerOpen(false);
      let markerArea = new markerjs2.MarkerArea(
        document.getElementById('sampleImage')
      );
      markerArea.renderImageType = 'image/jpeg';
      markerArea.renderAtNaturalSize = true;
      markerArea.renderImageQuality = 0.5;

      markerArea.settings.displayMode = 'popup';
      markerArea.uiStyleSettings.canvasBackgroundColor = '#000';
      markerArea.uiStyleSettings.redoButtonVisible = true;
      markerArea.uiStyleSettings.notesButtonVisible = true;
      markerArea.uiStyleSettings.clearButtonVisible = true;
      markerArea.targetRoot =
        document.getElementById('markerImage').parentElement;
      markerArea.addEventListener('beforeclose', (event) => {
        setIsMarkerOpen(true);
      });

      markerArea.addEventListener('render', (event) => {
        if (event.dataUrl !== 'data:,') {
          document.getElementById('markerImage').src = event.dataUrl;
        }
        setMarkerState(event.state);
        setIsMarkerOpen(true);
      });
      markerArea.show();
      setTimeout(() => {
        markerState && markerArea.restoreState(markerState);
      }, 500);
    }
  };

  const handleClickButton = async (isAsNew) => {
    try {
      const data = markerImageRef.current.src;
      // var getX = () => {
      //   return 45;
      // };

      // var getY = () => {
      //   return 430;
      // };

      // const watermarkImg = await watermark([data, noUser]).image(
      //   watermark.image.atPos(getX, getY, 1)
      // );

      // if (watermarkImg.src && watermarkImg.src.startsWith('blob:')) {
      //   setBlobURL({ ...blobURL, next: data });
      //   setTab(3);
      // } else {
      setBlobData && setBlobData(data);
      // const blob = CreateBlobUrl(data);
      // const test = URL.createObjectURL(blob);
      const test = hotFixCreateBlobUrl(data);

      setBlobURL({ ...blobURL, next: test });
      setTab(3);
      // }
      setPreviewScreen &&
        setPreviewScreen((prevState) => ({
          ...prevState,
          image: data,
        }));

      setIsAsNew?.(isAsNew);
      setMarkerImageModal && setMarkerImageModal(false);
    } catch (error) {
      console.error(error);
    }
  };
  const handleBack = () => {
    setBlobURL({
      ...blobURL,
      current: blobURL.previous,
      next: blobURL.previous,
    });
    setTab(1);
  };

  return (
    <>
      <div className='marker-parent'>
        <img
          src={path}
          alt='image'
          id='sampleImage'
          style={{
            maxWidth: '600px',
            visibility: 'hidden',
            // maxHeight: '60%',
            maxHeight: '1200px',
            objectFit: 'contain',

            left: 0,
          }}
          crossOrigin='anonymous'
        />
        <img
          className='marker-img-main'
          ref={markerImageRef}
          src={path}
          id='markerImage'
          alt='image'
          style={{ maxWidth: '50%', objectFit: 'contain' }}
          onClick={() => showMarkerArea()}
        />
      </div>
      <div className='img-editing-action-btn'>
        <button
          disabled={!isMarkerOpen}
          className='btn btn-primary'
          onClick={handleBack}>
          Back
        </button>
        {isSaveAsNew ? (
          <>
            <button
              className='btn btn-primary'
              disabled={!isMarkerOpen}
              onClick={(e) => {
                handleClickButton();
              }}>
              Save
            </button>
            <button
              className='btn btn-primary'
              disabled={!isMarkerOpen}
              onClick={(e) => {
                handleClickButton(true);
              }}>
              Save as new image
            </button>
          </>
        ) : (
          <>
            <button
              disabled={!isMarkerOpen}
              className='btn btn-primary'
              onClick={() => {
                handleClickButton(true);
              }}>
              Save
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default MarkerEditor;
